<template>
  <v-dialog v-model="model" max-width="800">
    <template #activator="{ on }">
      <slot name="activator" :on="on" />
    </template>
    <v-card>
      <v-card-title class="error--text"> Permissions </v-card-title>
      <v-card-text class="title">
        <v-form ref="form" @submit.prevent="onSubmit">
          <div class="d-flex">
            <v-select
              v-model="permission.role"
              :items="roles"
              color="pink"
              label="Role"
              class="mr-2"
              clearable
              @click:clear="permission.role === null"
            />
            <Autocomplete
              v-model="user"
              class="ml-2"
              item-text="email"
              item-value="email"
              :getter="getUsers"
              label="Give permission to user"
              prepend-icon="mdi-plus"
              @click:prepend="onAdd"
            />
          </div>
          <v-data-table :items="computedItems" :headers="headers">
            <template #item.remove="{ item }">
              <v-btn class="white--text" color="pink" small depressed @click="onRemove(item.user)">
                Remove <v-icon right>mdi-close-box</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="pink"
          :loading="loading"
          class="ml-auto white--text"
          depressed
          @click="onSubmit"
        >
          Save
          <v-icon right> mdi-content-save </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { loadFolderPermissions, createOrUpdatePermission, getProfiles } from "@/api/api";
import { rules } from "../../mixins/rulesMixin";
import Autocomplete from "../Autocomplete.vue";

export default {
  components: { Autocomplete },
  props: {
    address: { type: Object, required: true },
    value: Boolean,
  },
  data() {
    return {
      permission: {
        role: null,
        levels: [],
        users: [],
        folders: [this.address.uuid],
      },
      roles: [
        { text: "Teacher", value: "TEACHER" },
        { text: "Student", value: "STUDENT" },
      ],
      loading: false,
      rules,
      model: this.value,
      user: "",
      headers: [
        { text: "User", value: "user" },
        {
          text: "Remove",
          value: "remove",
          align: "right",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    computedItems() {
      return this.permission.users.map((i) => ({ user: i }));
    },
  },
  methods: {
    async onSubmit() {
      this.loading = true;
      try {
        await createOrUpdatePermission({
          ...this.permission,
          role: this.permission.role || "",
        });
        this.$emit("delete-address", this.address.uuid);
        this.model = false;
      } finally {
        this.loading = false;
      }
    },
    onAdd() {
      if (this.user) {
        const index = this.permission.users.findIndex((i) => i === this.user);
        if (index === -1) {
          this.permission.users.push(this.user);
        }
      }
    },
    onRemove(user) {
      const index = this.permission.users.findIndex((i) => i === user);
      if (index > -1) this.permission.users.splice(index, 1);
    },
    getUsers: getProfiles,
  },
  watch: {
    value(val) {
      this.model = val;
    },
    model(val) {
      this.$emit("input", val);
    },
  },
  async mounted() {
    this.loading = true;
    try {
      const permission = await loadFolderPermissions(this.address.uuid);
      if (permission) this.permission = permission;
    } finally {
      this.loading = false;
    }
  },
};
</script>
